import React from 'react';

const AdminLoadingScreen: React.FC<{ label?: string }> = ({ label = 'Loading admin workspace...' }) => (
  <div className="admin-shell flex min-h-screen items-center justify-center px-6">
    <div className="admin-panel w-full max-w-md p-8 text-center">
      <div className="mx-auto h-12 w-12 animate-spin rounded-full border-2 border-amber-300/20 border-t-amber-300" />
      <div className="mt-6 text-xl font-semibold text-white">{label}</div>
      <div className="mt-2 text-sm text-white/45">Connecting the shared draft workspace and live menu data.</div>
    </div>
  </div>
);

export default AdminLoadingScreen;
